import React from 'react'
import { View } from 'react-native'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { User } from '@src/types'
import { CoachAvatar } from '@src/components/Avatar/CoachAvatar'
import { getCoachDescriptor } from '@src/utils'

export interface MemberNoteCreatorInfoProps {
  creator: User
}

export const MemberNoteCreatorInfo = ({ creator }: MemberNoteCreatorInfoProps) => {
  const { firstName, lastName, coachProfile } = creator
  const { photo } = coachProfile || {}
  const styles = useStyleSheet(themedStyle)

  const coachName = `${firstName} ${lastName.charAt(0)}`
  const serviceTitle = getCoachDescriptor(creator).serviceTitle.toString()

  return (
    <View style={styles.content}>
      <CoachAvatar photo={photo} style={styles.photo} />
      <View style={styles.name}>
        <Text type="large">{coachName}</Text>
        {!!serviceTitle && (
          <Text type="small" style={styles.serviceTitle}>
            {serviceTitle}
          </Text>
        )}
      </View>
    </View>
  )
}

const themedStyle = StyleService.create({
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    gap: 8,
  },
  photo: {
    width: 44,
    height: 44,
    borderRadius: 32,
  },
  spinner: {
    color: 'theme.surface.base',
  },
  name: {
    justifyContent: 'space-between',
  },
  serviceTitle: {
    color: 'theme.text.secondary',
  },
})
